import {
  YOUTUBE_UPLOADS_LOADED,
  YOUTUBE_UPLOADS_LOAD_FAILURE
} from '../constants';

const initState = {
  loadComplete: false,
  uploads: []
};

const subscribeModalReducer = (state = initState, action) => {
  switch (action.type) {
    case YOUTUBE_UPLOADS_LOADED:
      return {
        ...state,
        loadComplete: true,
        uploads: action.payload
      };
    case YOUTUBE_UPLOADS_LOAD_FAILURE:
      return {
        ...state,
        loadComplete: true
      };
    default:
      return state;
  }
};

export default subscribeModalReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/youtubeReducer.js